import isEmpty from 'lodash/isEmpty';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';
import {getLinkedDocument, getNonEmpties} from './issues-helpers';
import isBoolean from 'lodash/isBoolean';
import PushpinsControl from '../services/lmv/pushpins-control';

const isIssueDocument3D = (currentSheet, document, issuePushpin) => {
  if (isBoolean(currentSheet?.is3D)) {
    return currentSheet.is3D;
  } else if (isBoolean(document?.is2d)) {
    return !document.is2d;
  } else if (issuePushpin) {
    return !isNullOrUndefined(issuePushpin.position.z) && issuePushpin?.position.z !== 0;
  }

  return false;
};
const getViewableObject = currentSheet => ({
  id: currentSheet.sheetGuid,
  name: currentSheet.sheetName,
  is3D: currentSheet.is3D,
  guid: currentSheet.sheetGuid,
  viewableId: currentSheet.viewableId
});

export const getDocumentName = (documentCollection, targetUrn) => {
  const document = documentCollection[targetUrn];
  if (!document) {
    return '';
  }
  return document.name;
};
export const isDocumentUnavailable = (documentCollection, targetUrn) =>
  // For unavailable document, the documentCollection[targetUrn] is an empty object.
  isEmpty(documentCollection) ||
  (documentCollection[targetUrn] &&
    (Object.keys(documentCollection[targetUrn]).length === 0 ||
      !isNullOrUndefined(documentCollection[targetUrn].error)));

export const constructLinkedDocument = ({issueAttributes, issuePushpin, document, targetUrn, currentSheet}) => {
  const issueDocument = getLinkedDocument(issueAttributes);
  if (targetUrn) {
    issueDocument.urn = targetUrn;
    if (issuePushpin) {
      const viewerState = Object.assign({}, issuePushpin.viewerState);
      if (viewerState && viewerState.objectSet?.length && viewerState.objectSet[0].id?.length) {
        const pushpinsControl = new PushpinsControl();
        const objectIds = viewerState.objectSet[0].id;
        viewerState.externalIdsMapping = pushpinsControl.getExternalIds(objectIds);
      }
      Object.assign(issueDocument, {
        type: issuePushpin.position.z ? 'TwoDVectorPushpin' : 'TwoDRasterPushpin',
        details: {
          ...getNonEmpties(issueDocument.details || {}),
          ...getNonEmpties({
            position: issuePushpin.position,
            objectId: issuePushpin.objectId,
            viewerState,
            externalId: issuePushpin.externalId
          })
        }
      });
    }
    if (document) {
      issueDocument.createdAtVersion = document.version || document.latestVersion;
    }
    if (currentSheet && currentSheet.sheetGuid) {
      if (!issueDocument.details) {
        issueDocument.details = {};
      }
      issueDocument.details.viewable = getViewableObject(currentSheet);
    }
    // We have multiple target urn's, we need to decide on which of the urn's we have to create the issue on
    // We do this, by using the urn of the object that got selected on screen
    if (Array.isArray(issueDocument.urn) && issuePushpin && issuePushpin.objectData) {
      const decodeUrn = urn => {
        urn = urn.replace(/-/g, '+');
        urn = urn.replace(/_/g, '/');
        while (urn.length % 4) {
          urn += '=';
        }
        return atob(urn);
      };
      // Read the urn from the object that got selected on screen
      const decodedUrn = decodeUrn(issuePushpin.objectData.urn);
      const lineageUrn = decodedUrn.match(/\.(?!.*\.).*\?/);
      if (lineageUrn) {
        // Find the lineage in the list of target urn's of the issues UI which matches the urn of the selected object
        const urn = issueDocument.urn.find(x => x.includes(lineageUrn[0].substr(1, lineageUrn[0].length - 2)));
        // Could be not there, if you have other content in LMV than in issues UI: create it on the first URN we have
        if (urn) {
          issueDocument.urn = urn;
          // Read and write the version of the selected object
          const versionNumber = decodedUrn.match(/\d*$/);
          if (versionNumber) {
            issueDocument.createdAtVersion = Number(versionNumber[0]);
          }
        }
      }
      issueDocument.details.viewable = {
        id: issuePushpin.objectData.guid,
        name: issuePushpin.objectData.viewName,
        guid: issuePushpin.objectData.guid,
        viewableId: issuePushpin.objectData.viewableId
      };
    }

    if (issueDocument.details?.viewable && !isBoolean(issueDocument.details.viewable.is3D)) {
      issueDocument.details.viewable.is3D = isIssueDocument3D(currentSheet, document, issuePushpin);
    }
  }
  return issueDocument;
};
